import React from 'react';

function PopUpAlert() {
  const path = 'oldPages/pop-up-alert/index.html';

  return <iframe title="pop-up-alert" src={path} className="z-[100] relative" width="100%" height="700px" />;
}

export default PopUpAlert;
